import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { UgerepDone, IndexCard } from '@store/models';
import { LuxonUtils } from '@shared';
import { ConfirmService } from 'app/shared/confirm-dialog/confirm-dialog.service';

interface IndexCardWithDone extends IndexCard {
    doneDag1: UgerepDone;
    doneDag2: UgerepDone;
    doneDag3: UgerepDone;
    doneDag4: UgerepDone;
    doneDag5: UgerepDone;
    doneDag6: UgerepDone;
    doneDag7: UgerepDone;
}

@Component({
    selector: 'app-employees-done-ui',
    templateUrl: './employees-done.component.html',
    styleUrls: ['../timetrack.shared.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EmployeesDoneComponent {

    @Input() usersWithDone: IndexCardWithDone[];
    @Input() employeesDone: UgerepDone[];
    @Input() year: number;
    @Input() week: number;
    @Input() today: number;
    @Input() lev: number;
    @Output() reopen = new EventEmitter<number>();

    displayColumns = ['navn', 'doneDag1', 'doneDag2', 'doneDag3', 'doneDag4', 'doneDag5', 'doneDag6', 'doneDag7'];


    get weekHeaders() {
        return LuxonUtils.datesInWeek(this.year, this.week);
    }

    constructor(
        private confirm: ConfirmService
    ) {}

    trackByCardid(_: number, user: IndexCardWithDone) {
        return user.cardId;
    }

    onReopen(user: IndexCardWithDone, day: number) {
        const ugerepDone = user['doneDag' + day] as UgerepDone;
        const ugerepDoneDate = new Date(ugerepDone.dato);
        this.confirm.question(
            `Vil du åbne ${ugerepDoneDate.toLocaleDateString()} for ${user.fornavn} ${user.efternavn}`,
            'Ja',
            'Nej').then(answer => {
                if (answer) {
                    this.reopen.emit(ugerepDone.id);
                }
            }
        );
    }

}
